<div class="mt-2">
  @if (gsEntry) {
    <cap-content-header [disableBreadcrumb]="true">
      <cap-title>
        <cap-kompakt-grundstueck-detail [item]="gsEntry" format="GRUNDSTUECK_TYP02"></cap-kompakt-grundstueck-detail>
        @if (isEigentuemer) {
          <span [ngbTooltip]="'meinGrundstueck.tooltip' | translate" class="ms-2 fas fa-user-circle"></span>
        }
        @if (gsEntry.sdrGeloeschtDatum) {
          <span class="ms-5 red fw-bold">
            <small>
              {{ "GeschlossenAm" | translate }}
              <span>
                {{ gsEntry.sdrGeloeschtDatum | datum }}
              </span>
            </small>
          </span>
        }
      </cap-title>
      <cap-title-functionbar>
        <div class="inline-form float-end">
          <button
            (click)="createGrundstueckAuszug()"
            [disabled]="isDownloading"
            class="btn btn-outline-primary btn-sm btn-actionpane"
            type="button">
            @if (isDownloading) {
              <span><i aria-hidden="true" class="fas fa-spinner fa-pulse fa-fw spinner"></i></span>
            } @else {
              <span><i aria-hidden="true" class="far fa-file-alt"></i></span>
            }
            {{ "Auszug" | translate }}
          </button>
          <cap-fremdsysteme [gsEntry]="gsEntry"></cap-fremdsysteme>
        </div>
      </cap-title-functionbar>
    </cap-content-header>
  }
  @if (gsEntry) {
    <div class="row mt-2">
      <div class="col-md-12 col-sm-12 col-lg-6">
        <cap-kopfdatenelement [histInfo]="gsEntry.histInfo" label="GrundstueckKopf.Label.Gemeinde">
          @if (gsNummerEntry.gbGemeinde?.id?.id) {
            <cap-link
              [enableNavigation]="true"
              [params]="[gsNummerEntry.gbGemeinde?.id?.id]"
              [target]="navTargets.NAV_GEMEINDE_GB"
              [tooltipParams]="{
                name: gsNummerEntry.gbGemeinde?.name | translateName
              }">
              {{ gsNummerEntry.gbGemeinde?.name | translateName }}
              <span
                >({{ gsNummerEntry.gbGemeinde.bfsNummer }}
                @if (gsNummerEntry.gbGemeinde.kreisNummer) {
                  <span>.{{ gsNummerEntry.gbGemeinde.kreisNummer }}</span>
                }
                )</span
              >
            </cap-link>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement [histInfo]="gsEntry.histInfo" label="GrundstueckNummer">
          {{ gsNummer }}
        </cap-kopfdatenelement>
        <cap-kopfdatenelement [histInfo]="gsEntry.histInfo" label="Grundstuecksart">
          {{ gsEntry | grundstueckArtLang }}
          @if (gsEntry.flaechenMaessigNichtAusgeschieden) {
            <span>{{ "FlaecheNichtAusgeschieden" | translate }}</span>
          }
        </cap-kopfdatenelement>
        <cap-kopfdatenelement [histInfo]="gsEntry?.histInfo" label="EGRID">
          @if (gsEntry.egrid) {
            <span>
              {{ gsEntry.egrid.value }}
            </span>
          }
        </cap-kopfdatenelement>
      </div>
      <div class="col-md-12 col-sm-12 col-lg-6">
        @if (gsEntry.mGrundbuchFuehrung.access !== "DEACTIVATED") {
          <cap-kopfdatenelement [histInfo]="gsEntry.histInfo" label="Grundbuchtyp">
            {{ gsNummerEntry.gbGemeinde.grundbuchFuehrung | translate }}
          </cap-kopfdatenelement>
        }
        <cap-kopfdatenelement [histInfo]="gsEntry.histInfo" label="FormDerFuehrung">
          {{ gsEntry.grundbuchFuehrung | translate }}
          @if (gsEntry.eidgenoessischSeit) {
            {{ "seit" | translate }}
            {{ gsEntry.eidgenoessischSeit | datum }}
          }
        </cap-kopfdatenelement>
        @if (gsEntry.histInfo?.mVonTimePoint.access !== "DEACTIVATED") {
          <cap-kopfdatenelement label="ErstelltMit">
            <cap-kompakt-timepoint [item]="gsEntry.histInfo.vonTimePoint" format="TIMEPOINT_TYP01"></cap-kompakt-timepoint>
          </cap-kopfdatenelement>
        }
        @if (gsEntry.histInfo?.mBisTimePoint.access !== "DEACTIVATED") {
          <cap-kopfdatenelement label="GestrichenMit">
            <cap-kompakt-timepoint [item]="gsEntry.histInfo.bisTimePoint" format="TIMEPOINT_TYP01"></cap-kompakt-timepoint>
          </cap-kopfdatenelement>
        }
      </div>
    </div>
  }

  @if (
    gsEntry.mAnzahlHaengigeGbGeschaefte.access !== "DEACTIVATED" ||
    gsEntry.mAnzahlHaengigeAuftraege.access !== "DEACTIVATED" ||
    gsEntry.mAnzahlHaengigeAvGeschaefte.access !== "DEACTIVATED"
  ) {
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      @if (permissionAuftragsmodul) {
        <span>{{ "HaengigeGeschaefteAufträge" | translate }} </span>
      } @else {
        <span>{{ "HängigeGeschäfte" | translate }} </span>
      }
    </span>
  }
  <div class="row mt-2">
    <div class="col-md-12 col-sm-12 col-lg-6">
      @if (gsEntry.mAnzahlHaengigeGbGeschaefte.access !== "DEACTIVATED") {
        <cap-kopfdatenelement
          [backgroundColor]="gsEntry.anzahlHaengigeGbGeschaefte ? '#fff3cd' : 'white'"
          class="haengigeGeschaefte"
          label="Grundbuchgeschäfte">
          @if (gsEntry.anzahlHaengigeGbGeschaefte) {
            {{ "Ja" | translate }}
          } @else {
            {{ "Nein" | translate }}
          }
        </cap-kopfdatenelement>
      }
      @if (permissionAuftragsmodul && gsEntry.mAnzahlHaengigeAuftraege.access !== "DEACTIVATED") {
        <cap-kopfdatenelement
          [backgroundColor]="gsEntry.anzahlHaengigeAuftraege ? '#fff3cd' : 'white'"
          class="haengigeGeschaefte"
          label="Auftraege">
          @if (gsEntry.anzahlHaengigeAuftraege) {
            {{ "Ja" | translate }}
          }
          @if (!gsEntry.anzahlHaengigeAuftraege) {
            {{ "Nein" | translate }}
          }
        </cap-kopfdatenelement>
      }
    </div>
    <div class="col-md-12 col-sm-12 col-lg-6">
      @if (gsEntry.mAnzahlHaengigeAvGeschaefte.access !== "DEACTIVATED") {
        <cap-kopfdatenelement
          [backgroundColor]="gsEntry.anzahlHaengigeAvGeschaefte ? '#fff3cd' : 'white'"
          class="haengigeGeschaefte"
          label="Geometergeschaefte">
          @if (gsEntry.anzahlHaengigeAvGeschaefte) {
            {{ "Ja" | translate }}
          }
          @if (!gsEntry.anzahlHaengigeAvGeschaefte) {
            {{ "Nein" | translate }}
          }
        </cap-kopfdatenelement>
      }
    </div>
  </div>
</div>
